import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

import { ElConfigProvider } from "element-plus";
// import zhCn from "element-plus/lib/locale/lang/zh-cn";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import contactUs from "@/views/operate/components/contactUs.vue";
import Feedback from "@/views/operate/components/Feedback.vue";
import UserSelect from "@/views/operate/components/UserSelect.vue";
import Visitor2ServiceProviderSignUpDialog from "@/views/operate/components/Visitor2ServiceProviderSignUpDialog.vue";
// import SubjectSelect from "@/views/operate/components/SubjectSelect.vue";
// import AccountChange from "@/views/operate/components/AccountChange.vue";
import NewNotice from "@/views/operate/components/NewNotice.vue";
import MobileLogin from "@/views/mobile/components/MobileLogin.vue";
import MobileFeedBack from "@/views/mobile/components/MobileFeedBack.vue";
import NewNoticeMobile from "@/views/mobile/components/NewNotice.vue";
import MobileUserSelect from "@/views/mobile/components/MobileUserSelect.vue";
// import { lazyInitSlardar } from "../src/utils/slardar";
// import store from "@/store";
import { onUnmounted, ref, watch, computed } from "vue";
import { postNoticeNew } from "@/api/request/user";
import store from "./store";
import Tea from "@dp/byted-tea-sdk-oversea";
import { onMounted } from "vue";
import cookieBanner from "@tiktok-fe/web-cookie-banner";
import { useRoute, useRouter } from "vue-router";
import en from "element-plus/dist/locale/en.mjs";
import ja from "element-plus/dist/locale/ja.mjs";
import ko from "element-plus/dist/locale/ko.mjs";
import { TtWid } from "@byted-ucenter/ttwid";
import Tool from "@/views/operate/components/Tool.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const isMobile = ref(false);
if (window.matchMedia("(max-width: 767px)").matches) {
  isMobile.value = true;
} else {
  isMobile.value = false;
}
// 是否是报告页
const isReport = computed(() => {
  return route.fullPath.indexOf("agentReport") !== -1 || route.fullPath === "/";
});
const arr = {
  "en-US": en,
  "zh-CN": zhCn,
  "ja-JP": ja,
  "ko-KR": ko,
} as { [props: string]: any };
const locale = ref(
  arr[
    (localStorage.getItem(process.env.VUE_APP_LANGURAGE as string) as string) ||
      "zh-CN"
  ]
);
store.commit(
  "SET_CURRENTLANGUAGE",
  localStorage.getItem(process.env.VUE_APP_LANGURAGE as string) || "zh-CN"
);
onMounted(() => {
  document.getElementsByTagName("html")[0].lang =
    (localStorage.getItem(process.env.VUE_APP_LANGURAGE as string) as string) ||
    "zh-CN";
  if (route.query.auth && route.query.auth === "login") {
    window.parent.location.href = window.parent.location.origin + route.path;
  }
  if (process.env.NODE_ENV !== "development") {
    // Tea = new Collector("tt4b_academy_api");
    Tea.init({
      app_id: 491147,
      channel: "sg",
      channel_domain: "https://mcs-sg.tiktokv.com",
      channel_type: "tcpy", // 如果你是Tik Tok或者musically业务这个参数一定要设置
      // caller: "ad.se.tt4b_academy_api",
      enable_stay_duration: true,
    });
    const uid = localStorage.getItem("tt4b_academy_uid");
    const userType = localStorage.getItem("tt4b_academy_type");
    const username = localStorage.getItem("tt4b_academy_username");
    if (uid && userType && username) {
      Tea.config({
        user_id: uid,
        user_type: parseInt(userType),
        user_is_login: 1,
        evtParams: {
          tt4b_uid: uid,
          tt4b_username: username,
          tt4b_user_type: userType,
        },
      });
    } else {
      Tea.config({
        user_is_login: 0,
      });
    }
    Tea.start();
    // lazyInitSlardar({ uid, userType, userName: username });
    // 启用 Cookie Banner
    cookieBanner.loadCookieBanner({
      locale: "zh-CN",
      //consentApiDomain: "https://academy-outbound-ads.tiktok.com",
      consentApiDomain: window.location.origin,
      apiDomain: window.location.origin,
    });
  }
});
window.addEventListener("unhandledrejection", (event) => {
  console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
});
let timer: number;
onUnmounted(() => {
  clearInterval(timer);
});
watch(
  () => store.state.user.userInfo.name,
  () => {
    if (store.getters.isLogin) {
      timer = setInterval(() => {
        postNoticeNew().then((res) => {
          if (res.data) {
            store.dispatch("PostMessage", res.data);
          }
        });
      }, 1000 * 60);
    } else {
      clearInterval(timer);
    }
  }
);

// check  检查 ttwid 是否有效
// 有效： 业务方域名下的 ttwid 可以正常使用
// 无效： 根据配置中的 union 去不同的地方注册 1002(不存在)，1003(需要续期)时
//       --- union 为 true,  调用 registerUnionWebId 统一注册 ttwid
//       --- union 为 false, 调用 registerOpenWebId  使用业务方自己域名注册 ttwid
async function check() {
  const webId = new TtWid({
    aid: 491147,
    service: "www.tiktokforbusiness-learning-center.com",
  });
  try {
    const check_res = await webId.checkWebId();
    console.log("check_res: ", check_res);
    if (check_res.status_code === 1002 || check_res.status_code === 1003) {
      const register_res = await webId.registerUnionWebId();
      console.log("register_res: ", register_res);
      //请求service域名中上web_id
      if (register_res.status_code === 0 && register_res.redirect_url) {
        fetch(register_res.redirect_url);
      }
    }
  } catch (ex) {
    console.log("check_ex: ", ex);
    // expect(String(ex)).not.toBeUndefined();
  }
}
if (window.location.origin.includes("tiktokforbusiness-learning-center.com")) {
  check();
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), {
    locale: locale.value,
    size: "small"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      (!isMobile.value && !_unref(isReport))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(contactUs),
            _createVNode(Feedback),
            (_unref(store).getters.isLogin)
              ? (_openBlock(), _createBlock(UserSelect, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(Visitor2ServiceProviderSignUpDialog),
            _createVNode(NewNotice)
          ], 64))
        : (!_unref(isReport) && _unref(store).state.user.overallIcon)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(MobileLogin),
              _createVNode(MobileFeedBack),
              (_unref(store).getters.isLogin)
                ? (_openBlock(), _createBlock(MobileUserSelect, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(NewNoticeMobile)
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})